var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17H11M21.5 17H15.5",
    stroke: "#0086D4",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11H20M15.5 11H9.5",
    stroke: "#0086D4",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 23H17",
    stroke: "#0086D4",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20V14C2 8.34314 2 5.51472 3.75735 3.75735C5.51472 2 8.34314 2 14 2H17C22.6568 2 25.4853 2 27.2426 3.75735C28.2224 4.73714 28.6559 6.04983 28.8478 8M29 14V20C29 25.6568 29 28.4853 27.2426 30.2426C25.4853 32 22.6568 32 17 32H14C8.34314 32 5.51472 32 3.75735 30.2426C2.77758 29.2628 2.34406 27.9501 2.15224 26",
    stroke: "#0086D4",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingDetails);
export default __webpack_public_path__ + "static/media/shippingDetails.237f2795a0822bea000d61556e3252d1.svg";
export { ForwardRef as ReactComponent };